import { Icon } from '@iconify/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { logout } from '@/patient-app-common/slices/authSlice';

export function ProviderExit() {
  const dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      return dispatch(logout());
    }, 5000);
  }, []);

  return (
    <div className="flex flex-row h-[100dvh] justify-center">
      <div className="flex flex-col justify-center">
        <h1 className="font-semibold text-3xl">
          Thank you for completing the survey
        </h1>
        <div className="mx-auto py-4 text-lg">
          <p>You can close this tab and return to your dashboard.</p>
          <div className="inline-flex">
            <p>This tab will be redirected to the patient login page shortly</p>
            <span className="text-4xl inline-flex place-self-end">
              <Icon className="animate-pulse" icon="bi:three-dots" />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
